export const dispatchCustomEvent = (eventName, eventDetail) => {
  const event = new CustomEvent(eventName, { detail: eventDetail })
  document.dispatchEvent(event)
}
